import type { FaireProductEntity } from "../../entity_types/product";

export const p_2shpjfer4m: FaireProductEntity = {
  token: "p_2shpjfer4m",
  type: "product",
  name: "Táche Unsweetened Original Barista Blend Pistachio Milk",
  brandToken: "b_jaxvn3rd8j",
  brandName: "Táche Pistachio Milk",
  imageUrl: "https://cdn.faire.com/fastly/5d0c909ce0adca8dd79d494b03f7759db5fda5e2915716c98c5636ae0f35b792.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/468f42df8fbf31c0e0debb0eed2c997bebfd181c99a820b1253c2422b00a85d3.png",
    "https://cdn.faire.com/fastly/ed3a2ed01ad7c777178e59c57b9099df5ea2f5e7ce1fc45216d72e5bc13bc87c.png",
    "https://cdn.faire.com/fastly/b051a24a6dd9322bf042291e902beb705091bd923ed693b8cfd65c028e593336.jpeg",
    "https://cdn.faire.com/fastly/d60c59d5f21e3521be534caa1cc308c96284c027608e8b7ff507e84d71707b54.png",
    "https://cdn.faire.com/fastly/b12e106cb946d1bf8742dc825279c2c1b08706df61155dea1eab373f9778ac6e.png"
  ],
  priceDollars: 4.5,
  description: "The Unsweetened version of our Original Barista Blend. Creamy, pure Pistachio Milk made without any added oil, fillers, or sugar. Designed to enhance warm beverages, this blend is perfect for froth fanatics.\n\n• Better tasting: A little bit nutty, no added sugar, and a velvety mouthfeel. Perfect in lattes, hot chocolate, and more.\n\n• Better for the planet: Pistachio trees require 75% less water than almonds.\n\n• Better for you: Unlike oat milk, Táche has no added rapeseed or canola oil.\n\n• Ready to enjoy: Táche is shelf stable with a shelf life of up to one year. Our milk ships in cases of 6 x 1L cartons. Pro tip: order in multiples of two cases for most efficient shipping.\n\n• Uniquely Táche: Try Táche in matcha, bubble tea, espresso drinks, and more. Reach out for recipe ideas!",
  tags: [],
  msrpDollars: 8.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:32.064Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
